import { render } from "./OrderAudioNotes.vue?vue&type=template&id=35147377&scoped=true"
import script from "./OrderAudioNotes.vue?vue&type=script&lang=js"
export * from "./OrderAudioNotes.vue?vue&type=script&lang=js"

import "./OrderAudioNotes.vue?vue&type=style&index=0&id=35147377&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35147377"]])

export default __exports__